import Link from "next/link";

import { useTradeInCampaign } from "@/api/TradeInApi";
import { useLocale } from "@/store/locale-store";
import { useTrans } from "@/utils/useTrans";

/** 이 안내를 붙이는 제품 — 쿠폰 대상 SKU 와 같다(계약 v0 `targetSku`). */
export const TRADE_IN_TARGET_SLUG = "tactsuit-pro";

/**
 * TactSuit Pro 제품 페이지의 보상판매 진입로(#6101 2026-11-02 변경 — PC Player 는 Pro 제품 페이지로만 보낸다).
 *
 * 두 겹으로 가린다:
 *   - 페이지가 넘기는 서버 판정(`isTradeInPageVisible`) — prod 공개 시각 전엔 이 컴포넌트를 아예 렌더하지 않는다
 *   - 캠페인이 `OPEN` 일 때만 그린다 — 시작 전·중단·종료·조회 실패에는 아무것도 없다(종료 뒤 신규 할인을 유도하지 않는다,
 *     조회 실패를 진행 중으로 단정하지 않는다 — 기획 2026-11-02 변경)
 *
 * 문구는 기획안 §8(Player 팝업) 영문 확정본을 쓴다 — 같은 고객에게 같은 말을 한다.
 */
export default function TradeInProNotice() {
  const { t } = useTrans(["shop"]);
  const { languageCode } = useLocale();
  const { data } = useTradeInCampaign();

  if (data?.kind !== "ok" || data.data.state !== "OPEN") return null;

  return (
    <div className="flex flex-col gap-2 rounded-lg border border-coolgray-20 bg-coolgray-10 p-4">
      <p className="text-base font-600 text-coolgray-90">
        {t(
          "Own a TactSuit X40 or TactSuit X16? Get 30% off TactSuit Pro and take your next step in haptics.",
        )}
      </p>
      <Link
        href="/trade-in"
        locale={languageCode}
        className="w-fit text-sm font-600 text-blue-60 underline"
      >
        {t("Explore the offer")}
      </Link>
    </div>
  );
}
